/*  MUI  */
import { Grid, TableCell, Typography } from '@mui/material';

/*  Shared  */
import { ApplicationNameLinkCell } from 'application/Shared/Components/ApplicationNameLinkCell';
import { ManagedTable } from 'application/Shared/Components/Table';
import { hmsFormatter } from 'application/Shared/Helpers';

/* Objects */
import { Application } from 'objects/Application';

/* React */
import React, { useMemo } from 'react';
import { withTranslation } from 'react-i18next';

/*  Components  */
import { ReportHeader } from '../internal/ReportHeader';

const PartnerApplicationUsageReports = (props) => {
    const { renderingScheduledReport, reportData, reportSetup } = props;

    if (!reportData) {
        return null;
    }

    const {
        partnerApplicationUsageTopApplicationsUsedTopApplicationsUsedLastWeek
    } = reportData;
    if (
        !partnerApplicationUsageTopApplicationsUsedTopApplicationsUsedLastWeek
    ) {
        return null;
    }

    const { startTime, endTime, type } = reportSetup;

    return (
        <>
            <ReportHeader
                startDate={startTime}
                endDate={endTime}
                reportType={type}
            />
            <TopApplicationsUsedLastWeek
                {...props}
                renderingScheduledReport={renderingScheduledReport}
                reportSetup={reportSetup}
                reportData={
                    partnerApplicationUsageTopApplicationsUsedTopApplicationsUsedLastWeek?.data
                }
            />
        </>
    );
};

const headers = (t) => [
    {
        align: 'left',
        field: 'riubCategory',
        renderHeader: <strong>{t('Common.category')}</strong>,
        width: '40%'
    },
    {
        align: 'left',
        field: 'riubUsers',
        renderHeader: <strong>{t('Common.client_count')}</strong>,
        width: '20%'
    },
    {
        align: 'left',
        field: 'riubUsers',
        renderHeader: <strong>{t('Common.user_count')}</strong>,
        width: '20%'
    },
    {
        align: 'right',
        field: 'riubUsers',
        renderHeader: <strong>{t('Common.usage')}</strong>,
        width: '20%'
    }
];

const TopApplicationsUsedLastWeek = (props) => {
    const { renderingScheduledReport, reportData, t } = props;

    const rows = useMemo(() => reportData.data, [reportData.data]);

    const tableHeaders = useMemo(() => headers(t), [t]);

    return (
        <Grid item lg={4} xs={12}>
            <Typography variant="h5">
                {t(
                    'Reports.PartnerApplicationOverviewReport.application_usage_by_category_breakdown'
                )}
            </Typography>
            <ManagedTable
                headers={tableHeaders}
                renderBody={(row) => (
                    <>
                        <TableCell>
                            <Application data={row.application} nameHasLink>
                                <ApplicationNameLinkCell nameNoTruncate />
                            </Application>
                        </TableCell>
                        <TableCell>{row.clients.length}</TableCell>
                        <TableCell>{row.users.length}</TableCell>
                        <TableCell align="right">
                            {hmsFormatter(row.usage)}
                        </TableCell>
                    </>
                )}
                renderBodyKey={null}
                renderFooter={!renderingScheduledReport}
                rows={rows}
                rowsPerPage={-1}
                searchEnabled={false}
                sortDirection="DESC"
                sortFieldType="number"
                sortKey="applicationCount"
            />
        </Grid>
    );
};

export default withTranslation()(PartnerApplicationUsageReports);
